import gql from 'graphql-tag'

export const UPDATE_GIVING_SUBSCRIPTION = gql`
  mutation updateGivingSubscription($callbackParamsEncoded: String!) {
    updateGivingSubscription(callbackParamsEncoded: $callbackParamsEncoded) {
      errors
    }
  }
`
